import { FormControl } from "@mui/material";
import React, { useEffect, useState } from "react";
import UserFilter from "../../../../../app/core/components/UserFilter/UserFilter";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { useGetUsersQuery } from "../../../../api/admin/gestisciUtentiApi";
import CoreTextArea from "../../../../../app/core/components/CoreTextArea/CoreTextArea";
import CoreButton from "../../../../../app/core/components/CoreButton/CoreButton";
import { t } from "i18next";

import { toast } from "react-toastify";
import {
  useDoCreateFolderMutation,
  useDoEditFolderMutation,
} from "../../../../api/admin/adminFolders";

const CreateFolder = ({ onClose, folder = false }) => {
  const [selectedUser, setSelectedUser] = useState("");
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [nameFolder, setNameFolder] = useState("");

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery({
    page: { startRow: 0, endRow: 50 },
    value: debouncedInputUserValue,
  });

  const [doCreateFolder, { isLoading: isCreatingFolder }] =
    useDoCreateFolderMutation();
  const [editFolder, { isLoading: loadingEdit }] = useDoEditFolderMutation();

  useEffect(() => {
    if (folder) {
      setNameFolder(folder.name);
    }
  }, [folder]);

  const handleInputChange = (e) => {
    setNameFolder(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const id = toast.loading(t("Creation..."), {
      type: "info",
    });

    const bodyFolder = {
      userId: selectedUser.id,
      name: nameFolder,
    };

    doCreateFolder(bodyFolder)
      .unwrap()
      .then((res) => {
        if (res.Result !== 1) {
          toast.update(id, {
            render: res.Exception || t("ReqErr"),
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          return;
        }

        toast.update(id, {
          render: t("FolderCreated"),
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
        onClose();
      });
  };

  const handleSumbitEdit = () => {
    const bodyEdit = {
      folderId: folder.id,
      name: nameFolder,
    };

    editFolder(bodyEdit).then((res) => {
      if (res.data.Result === 1) {
        toast.success(t("EditFolder"));
      } else if (res.data.Exception) {
        toast.error(res.data.Exception);
      }
    });
    onClose();
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <h2>{t("CreateFolder")}</h2>
      <FormControl className="w-3/4 space-y-5">
        {!folder && (
          <UserFilter
            selectedUser={selectedUser}
            setSelectedUser={(e) => {
              setSelectedUser(e);
            }}
            usersList={usersData?.Data?.items || []}
            setDebouncedInputUserValue={setDebouncedInputUserValue}
            isUsersLoading={isUsersLoading || isUsersFetching}
            isRequired
            startAdornment={<PersonRoundedIcon style={{ color: "#5c5c5c" }} />}
          />
        )}
        <CoreTextArea
          label="inserisci nome"
          type="text"
          name="nome"
          value={nameFolder}
          onChange={handleInputChange}
          rows={1}
        />
      </FormControl>
      <div style={{ marginTop: "40px" }}>
        <CoreButton
          disabled={isCreatingFolder}
          className={"btn-round"}
          variant="contained"
          testo={isCreatingFolder ? t("Wait") : t("Save")}
          onClick={folder ? handleSumbitEdit : handleSubmit}
        />
      </div>
    </div>
  );
};

export default CreateFolder;
